import { type IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@tenant/ui";
import styles from "./Perk.module.scss";

interface PerkProps {
  iconName: IconNameEnum;
  text: string;
  link: string;
}

export const Perk = ({ iconName, text, link }: PerkProps) => {
  const [block, cn] = useModuleBEM(styles, "Perk");
  return (
    <a
      className={block}
      href={link}
      target="_blank"
      rel="noopener"
      referrerpolicy="no-referrer-when-downgrade"
    >
      <Icon
        className={cn("image")}
        iconName={iconName}
        useCurrentColor={false}
      />
      <div className={cn("text")}>{text}</div>
    </a>
  );
};
